export const globalPromotionsManager = {
  header: {
    title: "إدارة العروض",
    description:
      "أنشئ وأدِر عروض الإقامة على مستوى الحساب. ستكون متاحة لأي من عقاراتك (الشقق والفنادق).",
  },

  toolbar: {
    info: "يمكن تفعيل العروض المُنشأة هنا من تبويب <strong>العروض</strong> في كل عقار.",
    newPromotion: "عرض جديد",
  },

  loading: "جارٍ تحميل العروض...",
  close: "إغلاق",
  cancel: "إلغاء",
  noLimit: "بلا حد",

  status: {
    active: "نشط",
    paused: "متوقف",
  },

  card: {
    stay: "الإقامة",
    discount: "الخصم",
    validity: "الصلاحية",
    edit: "تعديل",
    delete: "حذف",
  },

  nights: {
    range: "{min} – {max} ليلة",
    min: "{min}+ ليلة",
  },

  discount: {
    fixed: "{value} (ثابت)",
  },

  empty: {
    title: "لا توجد عروض مُنشأة",
    description:
      "أنشئ عروضًا لتشجيع الإقامات الأطول. يمكنك تفعيلها في كل عقار من إعدادات الحجوزات المباشرة الخاصة به.",
    create: "أنشئ أول عرض",
  },

  form: {
    editTitle: "تعديل العرض",
    createTitle: "عرض جديد",
    nameLabel: "اسم العرض",
    namePlaceholder: "مثال: خصم 7 ليالٍ، عرض الأسبوع",
    minNights: "الحد الأدنى لليالي",
    maxNights: "الحد الأقصى لليالي",
    optional: "(اختياري)",
    noLimitPlaceholder: "بلا حد",
    discountType: "نوع الخصم",
    percentage: "نسبة مئوية",
    fixedAmount: "مبلغ ثابت",
    discountValue: "قيمة الخصم",
    amountSuffix: "مبلغ",
    validFrom: "صالح من",
    validTo: "صالح حتى",
    activateNow: "تفعيل العرض فورًا",
    propertiesLabel: "العقارات التي سيتوفر فيها",
    selectAll: "تحديد الكل",
    propertiesHelper: "سيتم إنشاء سجلات إعداد للعقارات المحددة.",
    infoBox:
      "يمكنك لاحقًا ضبط الشارة والترتيب والسلوك من تبويب <strong>العروض</strong> في كل عقار.",
    saving: "جارٍ الحفظ...",
    update: "تحديث",
    create: "إنشاء العرض",
  },

  deleteModal: {
    title: "حذف العرض",
    warningStrong: "لا يمكن التراجع عن هذا الإجراء.",
    warningBefore: "أنت على وشك حذف العرض",
    warningAfter: ". لن يعود متاحًا في أي عقار.",
    confirmLabel: "اكتب الاسم تمامًا للتأكيد:",
    confirmPlaceholder: "اكتب اسم العرض",
    deleting: "جارٍ الحذف...",
    confirmDelete: "حذف نهائي",
  },

  toasts: {
    loadError: "تعذّر تحميل العروض.",
    nameRequired: "أدخل اسمًا للعرض",
    minNightsWarning: "يجب أن يكون الحد الأدنى لليالي 1 على الأقل",
    discountValueWarning: "يجب أن تكون قيمة الخصم أكبر من 0",
    selectProperty: "اختر عقارًا واحدًا على الأقل",
    updated: "تم تحديث العرض",
    created: "تم إنشاء العرض بنجاح",
    saveFailed: "تعذّر الحفظ",
    saveError: "خطأ أثناء حفظ العرض",
    deleted: "تم حذف العرض",
    deleteFailed: "تعذّر الحذف",
    deleteError: "خطأ أثناء الحذف",
  },
};
